module.exports = __webpack_public_path__ + "static/img/plus__icon.0737493f.svg";